/**
 * Section-type colour scheme, grouped by level (loosely following the Giants
 * season-ticket pricing chart). Used to colour the stadium map and its legend.
 */
export const SECTION_TYPE_COLORS: Record<string, string> = {
  // Club — purples
  'Coaches Club': '#5b21b6',
  'Mezz Club A': '#7c3aed',
  'Mezz Club B': '#8b5cf6',
  'Mezz Club B1': '#a78bfa',
  'Mezz Club C': '#c4b5fd',
  // Field (Lower) — blues
  'Field 1 Center': '#0b2265',
  'Field 1': '#1d4ed8',
  'Field 2': '#2563eb',
  'Field 3 Front': '#3b82f6',
  'Field 3 Back': '#60a5fa',
  // Mezzanine — teals
  'Mezzanine Front': '#0f766e',
  'Mezzanine Back': '#14b8a6',
  // Terrace (Upper) — ambers
  Loge: '#b45309',
  'Terrace Center': '#d97706',
  'Terrace Corner': '#f59e0b',
  'Terrace End Zone': '#fbbf24',
};

/** Display order for the legend, grouped by level. */
export const SECTION_TYPE_GROUPS: { level: string; types: string[] }[] = [
  { level: 'Club', types: ['Coaches Club', 'Mezz Club A', 'Mezz Club B', 'Mezz Club B1', 'Mezz Club C'] },
  { level: 'Field', types: ['Field 1 Center', 'Field 1', 'Field 2', 'Field 3 Front', 'Field 3 Back'] },
  { level: 'Mezzanine', types: ['Mezzanine Front', 'Mezzanine Back'] },
  { level: 'Terrace', types: ['Loge', 'Terrace Center', 'Terrace Corner', 'Terrace End Zone'] },
];

const FALLBACK = '#0b2265';

export function sectionTypeColor(type?: string | null): string {
  return (type && SECTION_TYPE_COLORS[type]) || FALLBACK;
}
